export const KANBAN_COLUMN_BATCH_SIZE = 20

export type KanbanColumnKey = 'todo' | 'in_progress' | 'done'

type ScrollPosition = {
  scrollTop: number
  clientHeight: number
  scrollHeight: number
}

export function shouldLoadMoreKanbanTasks(
  { scrollTop, clientHeight, scrollHeight }: ScrollPosition,
  thresholdPx = 80
): boolean {
  return scrollTop + clientHeight >= scrollHeight - thresholdPx
}
